/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { OfflineIndicator } from './OfflineIndicator';
import { UpdatePrompt } from './UpdatePrompt';
import { InstallButton } from './InstallButton';

/** Global PWA surfaces: offline banner, update-available prompt, install affordance. */
export function PwaStatus() {
  return (
    <>
      <OfflineIndicator />
      <UpdatePrompt />
      <InstallButton />
    </>
  );
}
